exports.default = {
  'download_success': '圖片下載成功',
  'download_failed': '圖片下載失敗',
  'code_copy_success': '代碼複製成功',
  'copy_failed': '複製失敗',
  'chart_not_found': '未找到圖表',
  'container_not_found': '容器未找到',
  'fullscreen_failed': '全屏顯示失敗',
  'image_copied_to_clipboard': '複製成功',
  'copy_image_failed_unsupported': '複製圖片失敗，您的瀏覽器可能不支持此功能',
  'copy_image_failed': '複製圖片失敗',
  // 工具欄相關
  'chart_tab': '圖片',
  'code_tab': '代碼',
  'download_image_tooltip': '下載圖片',
  'copy_image_tooltip': '複製圖片',
  'zoom_in_tooltip': '放大',
  'zoom_out_tooltip': '縮小',
  'fit_page_tooltip': '適應頁面',
  'fullscreen_tooltip': '全屏查看',
  'copy_code_tooltip': '複製代碼',
  // 狀態信息
  'image_generating': '圖片生成中',
  'image_generation_failed': '圖片生成失敗',
  'waiting_code_complete': '等待代碼完整...',
  'switch_to_code_view': '請切換到代碼視圖查看原始代碼'
}
